export class CredentialService {
  static _fullNameKey = "fullName";
  static _usernameKey = "username";
  static _userTypeKey = "userType";
  static _type = "";
  static _accessTokenKey = "accessToken";

  static getCredential() {
    const fullName = localStorage.getItem(CredentialService._fullNameKey) || "";
    const username = localStorage.getItem(CredentialService._usernameKey) || "";
    const userType = localStorage.getItem(CredentialService._userTypeKey);
    const accessToken =
      localStorage.getItem(CredentialService._accessTokenKey) || "";

    return {
      fullName,
      username,
      // userType: userType ? JSON.parse(userType) : null,
      accessToken,
    };
  }

  static setCredential({ username, userType, accessToken, fullName, type }) {
    localStorage.setItem(CredentialService._fullNameKey, fullName);
    localStorage.setItem(CredentialService._usernameKey, username);
    localStorage.setItem(
      CredentialService._userTypeKey,
      JSON.stringify(userType)
    );
    localStorage.setItem(CredentialService._accessTokenKey, accessToken);
    localStorage.setItem(this._type, type);
  }

  static clearCredential() {
    localStorage.removeItem(CredentialService._usernameKey);
    localStorage.removeItem(CredentialService._userTypeKey);
    localStorage.removeItem(CredentialService._accessTokenKey);
    localStorage.removeItem(CredentialService._fullNameKey);
  }
}
